import React from 'react';
import { InputNumber } from 'antd';

const FormInput = ( { header = '', setValue, defaultValue, width = 'auto' } ) => (
	<div className="input-wrapper">
		<h3 className="input-header">{ header }</h3>
		<InputNumber
			maxLength={ 6 }
			/*defaultValue={ defaultValue }*/
			placeholder={ 'Esimerkiksi 3000' }
			onBlur={ ( event ) => setValue( event.target.value ) }
			style={ { width, color: '#173456' } }
			size="large"
			type={ 'number' }
		/>
	</div>
);

export default FormInput;
